import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { postDocumentsResumeQueue } from '../requests';
import type { PostDocumentQueueResumeResponseType } from '../types';

export const usePostDocumentQueueResume = () => {
  const queryClient = useQueryClient();
  const { refetchAllDocumentsQueries } = useDocumentCache();

  /**
   * Handles the success response of the mutation.
   * It updates the query data for the document queue and refetches the document details.
   *
   * @param data - The response data from the resume queue request.
   * @param documentId - The mutation variable containing the overwrite document ID.
   */
  const onSuccess = async (
    data: PostDocumentQueueResumeResponseType,
    documentId: number,
  ) => {
    queryClient.setQueryData(
      [API_QUERY_KEYS.documentsQueue, { documentId }],
      data,
    );

    await queryClient.refetchQueries([API_QUERY_KEYS.document, { documentId }]);
    refetchAllDocumentsQueries();
  };

  return useMutation({
    mutationFn: (documentId: number) =>
      postDocumentsResumeQueue({
        documentId,
      }),
    onSuccess,
  });
};
